export const LogoMark = ({ size = 40 }) => (
  <img
    src="/logo-icon.png"
    alt="Safe Point Inspections logo mark"
    data-testid="logo-mark"
    style={{ width: size, height: size }}
    className="object-contain"
  />
);

export const LogoFull = ({ height = 46, plaque = false }) => (
  <img
    src={plaque ? "/logo.png" : "/logo-transparent.png"}
    alt="Safe Point Inspections — Home Inspection LLC"
    data-testid="logo-full"
    style={{ height }}
    className={`w-auto ${plaque ? "rounded-md ring-1 ring-obsidian/10" : ""}`}
  />
);
